import { Shark, View } from "shark-mvc";

import User from "../../models/User";

import templateContent from "./login.html";
import "./style.css";

import passwordRecoveryView from "../password-recovery/passwordRecoveryView";
import projectListView from "../project/projectListView";
import userManager from "../../controllers/userManager";

class LoginView extends View {
	
	constructor () {
		super("loginView");
		
		this.setTemplate(templateContent);
		this.$route = "sign";

		this.signViewNode = null;
	}

	afterLoad () {
		this.signViewNode = document.querySelector(".sign-view");
	}

	beforeLoad () {
		const lastUserEMail = localStorage.getItem("lastUserEMail") || "";
		const loggedUser = new User({email: lastUserEMail});

		loggedUser.set({password: ""});

		const newUser = new User();

		Shark.set({
			loggedUser,
			newUser,
			_createAccountButtonLabel: "Crea",
		});
	}

	login () {
		const { loggedUser}  = Shark.get();

		if (!loggedUser.isValid("login")) {
			loggedUser.set({
				email: document.querySelector("#emailField").value,
				password: document.querySelector("#passwordField").value,
			});
		}
		
		if (loggedUser.isValid("login")) {
			userManager.logIn(loggedUser)
			.then(loginResponse => {
				if (loginResponse.status === "ok") {
					Shark.set({
						loginError: false,
					});

					localStorage.setItem("preserveLogin", loggedUser.__preserveLogin);
					localStorage.setItem("lastUserEMail", loggedUser.email);
					Shark.openPage(projectListView);
				}
				else {
					alert("Non hai il permesso di accedere qui...");
				}
			});
		}
		else {
			Shark.render();
		}
	}

	loginBtn_clickHandler () {
		this.login();
	}

	beforeUnload () {
		Shark.set({
			errorMessage: null,
		});
	}
	
	createUserBtn_clickHandler () {
		const newUser = Shark.get("newUser");
	
		if (!newUser.isValid("register")) {
			this.showErrors();
			console.log(newUser);
		}
		else {
			this.resetErrors();

			Shark.$store._createAccountButtonLabel = "...attendi per favore...";

			userManager.register(newUser)
			.then(response => {
				console.log({response});
				if (response.status === "ok") {
					localStorage.setItem("lastUserEMail", newUser.email);
					// Shark.openPage(loginView);
					// alert("Account creato, puoi effettuare l'accesso!");

					this.resetSignUpForm();
					this.showSigninForm();
				}
				else {
					Shark.$store._createAccountButtonLabel = "Crea";

					if (response.data?.errors?.length > 0) {
						let errorMessage = response.data.errors[0].error;
						Shark.set({
							errorMessage,
						});
						Shark.render();
					}
				}
			});
		}
	}

	goBackToLoginViewBtn_clickHandler () {
		Shark.openPage(loginView);
	}
	
	navPasswordRecoveryViewBtn_clickHandler () {
		Shark.openPage(passwordRecoveryView, {urlSearchParams: null});
	}
	
	passwordField_keyupHandler (event) {
		if (event.key === "Enter") {
			this.login();
		}
	}

	resetErrors () {
		document.querySelectorAll(".is-invalid").forEach(item => item.classList.remove("is-invalid"));
	}

	resetSignUpForm () {
		Shark.$store._createAccountButtonLabel = "Crea";

		const signupForm = document.querySelector(".signupForm");

		if (signupForm) {
			signupForm.reset();
		}
	}

	showErrors () {
		this.resetErrors();

		const newUser = Shark.get("newUser");

		for (let currProp in newUser.__errors) {
			if (newUser.__errors[currProp] === true) {
				document.querySelectorAll(`[data-sh-prop="${currProp}"]`).forEach(item => item.classList.add("is-invalid"));
			}
		}
	}

	showSigninForm () {
		if (this.signViewNode) {
			this.signViewNode.classList.remove("up-active");
		}
	}

	showSigninBoxBtn_clickHandler () {
		this.showSigninForm();
	}

	showSignupForm () {
		if (this.signViewNode) {
			this.signViewNode.classList.add("up-active");
		}
	}

	showSignupBoxBtn_clickHandler () {
		this.showSignupForm();
	}
}

// signInView.addMethod("userManager_signedInHandler", function () {
// 	localStorage.setItem("lastUserEMail", Shark.get("loggedUser").email);

// 	if (Shark.get("loggedUser").preserveLogin) {
// 		localStorage.setItem("loggedUser", JSON.stringify(Shark.get("loggedUser")));
// 	}

// 	Shark.openPage(projectListView);
// });

// signInView.addMethod("userManager_errorHandler", function (event, info) {
// 	$("#signInMsgDisplay").html(info);
// });

const loginView = new LoginView();

Shark.registerView(loginView);

export default loginView;
